import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import useFormValidator from 'useFormValidator';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { get, getJson } from 'session';
import * as actions from '../action';
import * as c from '../constant';

function TransmittalModal() {
  const [formData, setFormData] = useState({
    rptax_batch_number: '',
  });
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const validateForm = useFormValidator(formData, {
    rptax_batch_number: 'required',
  });
  const setModal = useContext(ModalContext);

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // eslint-disable-next-line consistent-return
  const handleOnSubmit = e => {
    e.preventDefault();
    if (!validateForm.response.is_passed) {
      return false;
    }

    const src = `${process.env.REACT_APP_WS}${
      c.RPT_TAX_CLEARANCE_TRANSMITTAL
    }?bearer_token=${token}
    &email=${_.get(authProfile, 'email')}&transmittal_no=${_.get(
      formData,
      'rptax_batch_number'
    )}&output=D`;

    setTimeout(() => {
      window.location.href = src;
    }, 100);
    setModal({ isOpen: false });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Batch Number: {validateForm.renderMessage('rptax_batch_number')}
            </label>
            <input
              className="form-control"
              min="1"
              name="rptax_batch_number"
              onChange={onChange}
              value={_.get(formData, 'rptax_batch_number')}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">Print</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(TransmittalModal);
